import { Box, BoxProps, CircularProgress } from "@mui/material"

export interface CenteredBoxProps extends BoxProps {
	fullScreen?: bool
}
export function CenteredBox({ children, fullScreen = true, ...rest }: CenteredBoxProps) {
	return (
		<Box
			{...rest}
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: fullScreen ? "100vh" : 500,
				...rest.sx,
			}}
		>
			{children}
		</Box>
	)
}

export function Loading(props: CenteredBoxProps): React.JSX.Element {
	return (
		<CenteredBox {...props}>
			<CircularProgress />
		</CenteredBox>
	)
}
